import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { Input, InputContent, InputContentInput, InputContentLabel } from '@bshgroup/component-input';
import { Text } from '@bshgroup/component-text';
import Button from '../components/core/Button/Button';
import LinearLayout from '../components/core/LinearLayout/LinearLayout';

const localStorageKey = 'API_KEY';

export interface ApiKeyContextInterface {
  apiKey: string;
}

const ApiKeyContextContext = createContext<ApiKeyContextInterface>({
  apiKey: '',
});

export function useApiKey() {
  return useContext(ApiKeyContextContext);
}

// texts in the API key input prompt are not translated because the context is not available at that stage. Should be okay as this is for development only
export default function ApiKeyContext({ children }: { children: ReactNode }) {
  const [apiKey, setApiKey] = useState<string>(
    typeof localStorage !== 'undefined' ? localStorage.getItem(localStorageKey) || '' : '',
  );
  const [apiKeyInput, setApiKeyInput] = useState<string>('');

  const value = useMemo(() => {
    return { apiKey };
  }, [apiKey]);

  const checkApiKey = () => {
    // TODO actual API key check
    localStorage.setItem(localStorageKey, apiKeyInput);
    setApiKey(apiKeyInput);
  };

  if (apiKey) {
    return <ApiKeyContextContext.Provider value={value}>{children}</ApiKeyContextContext.Provider>;
  } else {
    return (
      <div css={{ height: '100vh', display: 'grid', placeContent: 'center' }}>
        <LinearLayout orientation="vertical" css={{ maxWidth: '20rem' }}>
          <Text size="md" variant="default" css={{ textAlign: 'center' }}>
            Please enter the API Key to continue
          </Text>
          <Input
            size="lg"
            variant="default"
            content={config => (
              <InputContent
                {...config}
                label={config => (
                  <InputContentLabel {...config} as="label" htmlFor="apiKeyInput">
                    API Key
                  </InputContentLabel>
                )}
                input={config => (
                  <InputContentInput
                    {...config}
                    value={apiKeyInput}
                    onChange={e => setApiKeyInput(e.target.value)}
                    id="apiKeyInput"
                  />
                )}
              />
            )}
          />
          <Button variant="prominent" onClick={checkApiKey}>
            Check
          </Button>
        </LinearLayout>
      </div>
    );
  }
}
